import { Buttons } from '../../../controls/buttons';
import { Layouts } from '../../../controls/layouts';
import { Component, computed, inject, linkedSignal, resource, signal, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ModalDialogComponent } from 'src/app/controls/components/advanced/modal-dialog/modal-dialog.component';
import { PartnerContactService } from '../../services/partner-contact.service';
import { PartnerContact, PartnerContactType } from 'src/app/partnerportal/models/partner-onboarding';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Selectbox } from '../../../controls/selectbox';

@Component({
  selector: 'app-partner-onboarding-accept-contact-dialog',
  standalone: true,
  imports: [ModalDialogComponent, FormsModule, Buttons, ModalDialogComponent, Layouts, Selectbox],
  templateUrl: './partner-onboarding-accept-contact-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './partner-onboarding-accept-contact-dialog.component.scss'
})
export class PartnerOnboardingAcceptContactDialogComponent {
  private dialog = inject(NgbActiveModal);
  private partnerContactService = inject(PartnerContactService);

  public partnerContact = signal<PartnerContact>(null);
  public dialogResult = signal<PartnerOnboardingAcceptContactDialogResult>(null);

  contactTypesResource = resource({
    params: () => ({}),
    loader: () => this.partnerContactService.getContactTypes(),
  });

  contactTypes = computed(() => {
    const contactTypes = this.contactTypesResource?.value();
    return contactTypes?.map(c => ({ Name: c.Name, Id: c.Id }) ) ?? [];
  });

  selectedContactTypes = computed(() => {
    const selectedIds = this.selectedContactTypeIds();
    return this.contactTypes().filter(ct => selectedIds.includes(ct.Id));
  });

  selectedContactTypeIds = linkedSignal<number[], number[]>( {
    source: () => this.partnerContact().Types.map(t => t.Id),
    computation: (newContactTypes) => newContactTypes
  });

  result = computed(() => {
    const result: PartnerOnboardingAcceptContactResult = {
      contactTypes: this.selectedContactTypes(),
      dialogResult: this.dialogResult()
    }
    return result;
  });

  accept() {
    this.dialogResult.set(PartnerOnboardingAcceptContactDialogResult.Accept);
    this.dialog.close(this.result());
  }

  acceptAndCreate() {
    this.dialogResult.set(PartnerOnboardingAcceptContactDialogResult.AcceptAndCreate);
    this.dialog.close(this.result());
  }

  cancel() {
    this.dialogResult.set(PartnerOnboardingAcceptContactDialogResult.Cancel);
    this.dialog.close(this.result());
  }
}

export interface PartnerOnboardingAcceptContactResult {
  contactTypes: PartnerContactType[];
  dialogResult: PartnerOnboardingAcceptContactDialogResult;
}

export enum PartnerOnboardingAcceptContactDialogResult {
  Accept,
  AcceptAndCreate,
  Cancel
}
